import type { IPlatformDashboardSignupSourceSegment } from '@brushfire/types'
import { PlatformChartComingSoonCard } from './PlatformChartComingSoonCard'

interface Props {
  segments: IPlatformDashboardSignupSourceSegment[]
}

/** Hardcoded Coming Soon — chart disabled until signup source UI is in scope. */
export function SignupSourceSplitChart(_props: Props) {
  return (
    <PlatformChartComingSoonCard
      title="Sign-up Source Split"
      testId="platform-signup-source-chart"
    />
  )
}
